export default {
    path: '/bindingsenduser',
    meta: {
        title: '信息接收人绑定身份',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/bindingsenduser`),
}


// WEBPACK FOOTER //
// ./src/views/bindingSendUser/router.js